import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import {
  Modal,
  OrganizationSwitcher,
  ConfigurationFile,
  Logo,
  LogoMin
} from 'containers/misc'
import { Breadcrumbs } from 'components/layout'
import { Dropdown } from 'components/misc'
import { getFullName, multipleOrganizations } from 'utils/token'
import SearchAllForm from 'containers/forms/search/SearchAllForm/SearchAllForm'
import styles from './header.styl'
import getHeaderColorStyle from 'helpers/getHeaderColorStyle'
import { CONFIGURATION_KEYS } from 'constants/enums'
import config from 'config'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { apiOrganizations } from '../../../helpers/decorators/api'
import Image from '../../../containers/misc/Image/Image'

const headerColorStyle = getHeaderColorStyle()

const actions = [
  {
    id: 1,
    label: 'Profile',
    action: `${config.publicPath}/profile`,
    intlKey: 'label.profile',
    forMultiple: false
  },
/*  {
    id: 2,
    label: 'Frequently asked questions',
    action: 'FAQ',
    intlKey: 'label.frequently_asked_questions',
    type: 'button',
    forMultiple: false
  },*/
  {
    id: 3,
    label: 'Switch organisation',
    action: 'SWITCH_ORGANISATION',
    intlKey: 'label.switch_organization',
    type: 'button',
    forMultiple: true
  },
  // {
  //   id: 3,
  //   label: 'Frequently asked questions',
  //   action: `${config.publicPath}/logout`,
  //   forMultiple: false
  // },
  {
    id: 5,
    label: 'Logout',
    action: `${config.publicPath}/logout`,
    intlKey: 'label.logout',
    forMultiple: false
  }
]

const enhance = compose(
  apiOrganizations(),
  connect(
    ({ api }) => ({
      customization: api.organizations.customization
    }), {}
  ),
)
class Header extends Component {
  static propTypes = {
    user: PropTypes.object,
    organization: PropTypes.object,
    page: PropTypes.object,
    photoUrl: PropTypes.string,
    routes: PropTypes.array,
    modal: PropTypes.func,
    push: PropTypes.func,
    location: PropTypes.object,
    isBlank: PropTypes.bool,
    isGOPEnabled: PropTypes.bool.isRequired,
    onGetOrganizationClientCustomization: PropTypes.bool.isRequired
  }

  componentDidMount = async() => {
    const { organization } = this.props

    await this.props.onGetOrganizationClientCustomization(get(organization, 'id'))
  }

  static defaultProps = {
    isBlank: false
  }

  handleAction = actionType => {
    switch (actionType) {
      case 'SWITCH_ORGANISATION':
        this.props.modal('modal-organization-switcher')
        break
      case 'FAQ':
        this.props.modal('modal-faq')
        break
      default:
    }
  }

  handleTitleClickRedirect = page => {
    let redirectTo

    if (get(page, 'options.participantId')) {
      redirectTo = () =>
        this.props.push(`${config.publicPath}/participants/${page.options.participantId}`)
    }

    return (
      <span
        onClick={redirectTo}
        style={redirectTo ? { cursor: 'pointer' } : undefined}
      >
        {get(page, 'title') || ' '}
      </span>
    )
  }

  render() {
    const { user, organization, page, photoUrl, location, isBlank, isGOPEnabled, customization } = this.props

    const simpleClass = !get(page, 'breadcrumbs') ? styles.simple : ''

    let filterredActions = actions

    // create a selector
    if (!multipleOrganizations(user)) {
      filterredActions = actions.filter(item => !item.forMultiple)
    }

    const logoUrl = get(customization, 'organization.logoUrl')

    return (
      <header className={styles.header} style={headerColorStyle}>
        <div className={styles.logo}>
          {logoUrl && <Image src={logoUrl} alt="Organization logotype" />}
          {!logoUrl && <Logo className={styles.img} />}

        </div>
        <div className={styles.logoMin}>
          <LogoMin className={styles.img} />
        </div>
        <div className={styles.main}>
          <div className="container">
            <div className="row">
              <div className="col-xs-6">
                {!isBlank && <div className={`${styles.heading} ${simpleClass}`}>
                  <div className={styles.title}>
                    {this.handleTitleClickRedirect(page)}
                  </div>
                  {get(page, 'breadcrumbs') && location && <Breadcrumbs location={location} />}
                </div>}
              </div>
              {user && !isBlank &&
                <div className={`col-xs-6 ${styles.controlsRight}`}>
                 <SearchAllForm />

                  <div className={styles.dropdown}>
                    <Dropdown
                      user={user}
                      defaultAction="/"
                      title={getFullName(user)}
                      subtitle={get(organization, 'name')}
                      photoUrl={photoUrl}
                      multipleOrganizations={multipleOrganizations(user)}
                      actions={filterredActions}
                      onAction={this.handleAction}
                    />
                  </div>
                </div>}
            </div>
          </div>
        </div>
        <div className={styles.separators}>
          <div className={styles.separator1} />
          <div className={styles.separator2} />
          <div className={styles.separator3} />
          <div className={styles.separator4} />
          <div className={styles.separator5} />
        </div>
        <Modal
          id="modal-organization-switcher"
          customActions
          showCloseBtn
          enableOverflow
        >
          <OrganizationSwitcher isGOPEnabled={isGOPEnabled} />
        </Modal>
        <Modal id="modal-faq" customActions showCloseBtn>
          <ConfigurationFile
            configKey={CONFIGURATION_KEYS.faqDocuments.id}
            isPublic
            autoDownload
            formattedName={
              <FormattedMessage
                id="label.user_app_guide_leader"
                defaultMessage="User app guide - Award Leader"
              />
            }
          />
        </Modal>
      </header>
    )
  }
}

export default enhance(Header)